import {
  closeModalSafely as closeModalSafelyBase,
  handleSubmit as handleSubmitBase,
} from '../modals.service';

export const closeModalSafely = closeModalSafelyBase;

export const handleSubmit = (
  event,
  errors,
  values,
  targetPrinterConfig,
  isEditMode,
  setIsSubmitting,
  setTargetPrinterConfig,
  closeModal,
  onSubmit,
  type,
) =>
  handleSubmitBase(
    type === 'RegoPrinterConfig'
      ? 'printer-configs/rego'
      : 'printer-configs/bridge',
    'editPrinterConfigSuccess',
    'editPrinterConfigError',
    'createPrinterConfigSuccess',
    'createPrinterConfigError',
    event,
    errors,
    values,
    targetPrinterConfig,
    isEditMode,
    setIsSubmitting,
    setTargetPrinterConfig,
    closeModal,
    onSubmit,
    type,
  );
